import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.XeroAmaxPayBatchPaymentForm.SelectBankAccountPopup.BankAccountCard',
    {
        bankAccountNumber: 'Account number: {value}',
        currencyCode: 'Currency',
        sortCode: 'Sort code: {value}',
        iban: 'IBAN: {value}',
        noXeroBankAccount: 'Xero bank account is missing',
        disconnected: 'Disconnected',
    }
);
